import React from "react";
import styled from "styled-components";
import { Droppable } from "react-beautiful-dnd";
import { AdminGroupItem } from "../components";

const AdminGroupDraggableElement = ({ prefix, elements }) => {
  if (prefix.name === "registros") {
    return (
      <WrapperRegisters>
        <ColumnHeader>{prefix.name}</ColumnHeader>
        <Droppable droppableId={`${prefix.id}`}>
          {(provided) => (
            <DroppableArea {...provided.droppableProps} ref={provided.innerRef}>
              {elements.map((item, index) => (
                <AdminGroupItem
                  key={`groupItem-${prefix.id}-${prefix.name}-${prefix.group}-${item}`}
                  item={item}
                  index={index}
                  size="50%"
                />
              ))}
              {provided.placeholder}
            </DroppableArea>
          )}
        </Droppable>
      </WrapperRegisters>
    );
  }

  return (
    <Wrapper>
      <ColumnHeader className="division-name">
        <b>{prefix.name}</b>{" "}
        <span>
          <b>Grupo:</b> {prefix.group} <i>({prefix.players.length} players)</i>
        </span>
      </ColumnHeader>
      <Droppable droppableId={`${prefix.id}`}>
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {elements.map((item, index) => (
              <AdminGroupItem
                key={`groupItem-${prefix.id}-${prefix.division}-${prefix.group}-${item}`}
                item={item}
                index={index}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </Wrapper>
  );
};

const DroppableArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Wrapper = styled.div`
  border: 2px solid var(--clr-red-light);
  padding: 10px;
  border-radius: 6px;
  background: var(--clr-black);
  width: 50%;
  outline: 8px;

  .division-name {
    display: flex;
    justify-content: space-between;
  }
`;
const ColumnHeader = styled.div`
  text-transform: uppercase;
  margin-bottom: 20px;
`;

const WrapperRegisters = styled.div`
  width: 100%;
  margin: 8px;
  border: 2px solid var(--clr-dark-violet);
  padding: 10px;
  border-radius: 6px;
  background: var(--clr-black);

  .small-item {
    width: 49%;
  }
`;

export default AdminGroupDraggableElement;
